/* src/components/admin/AdminDashboard.js */
import React from 'react';
import { useProfile } from '../../contexts/ProfileContext';

const AdminDashboard = () => {
    const { authUser } = useProfile(); // Get user info if needed

    // Placeholder data (replace with actual data fetching later)
    const stats = {
        totalUsers: 1234,
        activeSessionsToday: 56,
        pendingFeedback: 3,
    };

    return (
        <div className="bg-white p-6 rounded-lg shadow-md">
            <h1 className="text-2xl font-semibold text-gray-800 mb-6">
                Admin Overview
            </h1>

            {authUser && (
                 <p className="text-gray-600 mb-6">
                    Welcome, {authUser.displayName || authUser.email}!
                 </p>
            )}

            {/* Placeholder Stats Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                <div className="bg-blue-50 border border-blue-200 p-4 rounded-lg text-center">
                    <h3 className="text-sm font-medium text-blue-800 uppercase tracking-wider">Total Users</h3>
                    <p className="text-3xl font-bold text-blue-900 mt-1">{stats.totalUsers}</p>
                </div>
                <div className="bg-green-50 border border-green-200 p-4 rounded-lg text-center">
                    <h3 className="text-sm font-medium text-green-800 uppercase tracking-wider">Active Sessions (Today)</h3>
                    <p className="text-3xl font-bold text-green-900 mt-1">{stats.activeSessionsToday}</p>
                </div>
                 <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg text-center">
                    <h3 className="text-sm font-medium text-yellow-800 uppercase tracking-wider">Pending Feedback</h3>
                    <p className="text-3xl font-bold text-yellow-900 mt-1">{stats.pendingFeedback}</p>
                </div>
            </div>

            {/* Placeholder for future actions/links */}
            <div className="border-t pt-6">
                 <h2 className="text-lg font-medium text-gray-700 mb-4">Quick Actions</h2>
                 <div className="space-y-2">
                    <p className="text-sm text-gray-500">- Manage Users (Coming Soon)</p>
                    <p className="text-sm text-gray-500">- View Feedback (Coming Soon)</p>
                    <p className="text-sm text-gray-500">- System Settings (Coming Soon)</p>
                 </div>
            </div>

        </div>
    );
};

export default AdminDashboard;